import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ExchangeRatesResponse } from '@/types/general';

import type { RootState } from '..';

// Define the initial state for the currencies slice
interface GeneralSliceState {
  currencies: ExchangeRatesResponse | null;
  selectedOperator: string | null;
  tags: string[] | null;
}

const initialState: GeneralSliceState = {
  currencies: null,
  selectedOperator: null,
  tags: null,
};

// Create the currencies slice
export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    // Reducer to add currencies to the state
    addCurrencies: (state, action: PayloadAction<ExchangeRatesResponse>) => {
      state.currencies = action.payload;
    },
    changeOperator: (state, action: PayloadAction<string>) => {
      state.selectedOperator = action.payload;
    },
    addTags: (state, action: PayloadAction<string[]>) => {
      state.tags = action.payload;
    },
  },
});

// Export the action creators
export const { addCurrencies, changeOperator, addTags } = generalSlice.actions;

export const getGeneral = (state: RootState): GeneralSliceState => state.general;

export const getSelectedOperator = (state: RootState): string | null => state.general.selectedOperator;
